import React from "react"
import "./FavouritesComp.scss"
import ModalActionBtn, { ModalBtnType } from '../../../CommonComponents/ModalButtons/ModalActionBtn/ModalActionBtn'
import StarIcon from '@mui/icons-material/Star';
import { Gig } from '../../../../Models/Gig';
import { useNavigate } from "react-router-dom";

interface FavouritesCompPropInterface {
  gigList: Gig[],
  closePanel: Function
  removeFromWishList: (gigId: string) => void
}

const FavouritesComp = (props: FavouritesCompPropInterface) => {
  const navigate = useNavigate()
  const { gigList, closePanel, removeFromWishList } = props;

  const dataMapper = (gig: Gig) => {
    const proceedBtnClicked = () => {
      closePanel()
      navigate("/gig/" + gig.id)
    }

    return (
      <div className='favouriteMsgBox'>
        <div className="favLeft">
          <img src={ gig.coverImg } alt="message img" />
        </div>
        <div className="favRight">
          <p className="favMsg">{ gig.title }</p>
          <div className="favUserBar">
            <div className="favUserIcon">
              <img src={ gig.seller.coverImage } alt="" />
              <span>{ gig.seller.fullName }</span>
            </div>
            <div className="favRating">
              <StarIcon className='rateIcon' />
              <div>{ gig.rating }</div>
            </div>
          </div>
          <div className="favActionBar">
            <div className="favActionLeft">₹{ gig.minPrice }</div>
            <div className="favActionRight">
              <ModalActionBtn text='Remove From Wishlist' type={ModalBtnType.light} callToAction={() => removeFromWishList(gig.id)} />
              <ModalActionBtn text='Proceed' type={ModalBtnType.dark} callToAction={proceedBtnClicked} />
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <>
      { gigList.map((i, index) => <React.Fragment key={i.id ?? index}>{dataMapper(i)}</React.Fragment>) }
    </>
  )
}

export default FavouritesComp